import React from 'react';
import { NukiPremiumActivationForm } from '../../pages/nuki-premium-activation/nuki-premium-activation';
import Container from '../../shared/Container';

type NukiPremiumActivationFormTileProps = {
  trackingPrefix?: string;
};

export default function NukiPremiumActivationFormTile({
  trackingPrefix,
}: Readonly<NukiPremiumActivationFormTileProps>) {
  return (
    <Container>
      <NukiPremiumActivationForm trackingPrefix={trackingPrefix} />
    </Container>
  );
}
